import { all, takeLatest } from 'redux-saga/effects';

import { PERSIST_ALL } from '../constants/actionTypes';

import { applicationUpdateWorker } from './applicationUpdate';
import { progressSendWorker } from './progressSend';

function* persistAllWatcher() {
  yield takeLatest(PERSIST_ALL, persistAllWorker);
}

function* persistAllWorker(action) {
  yield all([progressSendWorker(action), applicationUpdateWorker(action)]);
}

export { persistAllWorker };
export default persistAllWatcher;
